import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Box, Divider } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useFeatureUpdates } from "../hooks/useFeatureUpdates";
import { useTranslation } from "react-i18next";
import FeatureUpdateArticle from "./featureUpdates/FeatureUpdateArticle";

interface FeatureUpdatesModalProps {
  open: boolean;
  onClose: () => void;
}

export default function FeatureUpdatesModal({ open, onClose }: FeatureUpdatesModalProps) {
  const { t } = useTranslation();
  const { allUpdates, markAllAsSeen } = useFeatureUpdates();

  const handleClose = () => {
    markAllAsSeen();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: 800,
          width: "95vw",
          height: "95vh",
          backgroundColor: "grey.200"
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
          px: 3,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper"
        }}
      >
        <Typography variant="h4" component="span">{t("featureUpdates.title")}</Typography>
        <IconButton onClick={handleClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: { xs: 2, sm: 3 }, overflowY: "auto" }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {allUpdates.map((update, index) => (
            <Box key={`${update.id}-${update.title}`}>
              <FeatureUpdateArticle update={update} />
              {index < allUpdates.length - 1 && <Divider sx={{ my: 4 }} />}
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
